// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__21WsT","alert":"SettungsInbox_alert__2PYEe"};